var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageShell',{staticClass:"page-shell-wrapper--home",attrs:{"locale":"id","hide-title":""}},[_c('HomeContent',{attrs:{"locale":"id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }